import React from 'react';
import {
	Box,
	Typography,
	makeStyles,
	useMediaQuery,
	useTheme
} from '@mui/material';
import { makeStyles as muiStyles } from '@mui/styles';

const SubheaderV2 = ({ title, buttons, ...props }) => {
	const classes = useStyles();
	const theme = useTheme();
	// Check if the screen size is 'sm' or below
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box className={classes.box} px={4} pt={4}>
			<Box
				width="66.6%"
				minHeight="50px"
				display="flex"
				flexDirection="row"
				justifyContent="space-between"
			>
				<Box ml={isMobile ? 6 : 3} mt={1.5}>
					<Typography color="textPrimary" variant="h4">
						{title}
					</Typography>
				</Box>
			</Box>
			<Box width="33.3%" display="flex" justifyContent="flex-end">
				{buttons &&
					buttons.map((button, i) => (
						<Box m={1} key={i}>
							{button}
						</Box>
					))}
			</Box>
		</Box>
	);
};

export default SubheaderV2;

const useStyles = muiStyles((theme) => ({
	box: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between'
	}
}));
